import React from 'react';

// Phone-style screen header: ‹ 書庫 | centered title | right slot (e.g. 剩 N).
export default function BackHeader({ title, onBack, right = null }) {
  return (
    <header className="ph-header">
      <button className="ph-back" onClick={onBack}>‹ 書庫</button>
      <span className="ph-htitle">{title}</span>
      <span className="ph-hright">{right}</span>
    </header>
  );
}
